/* eslint-disable(prettier/prettier) */
// 🔴 DO NOT EDIT — This file is generated.
import DownDoubleArrowSvg from './DownDoubleArrowSvg'
import MobileArticlesSvg from './MobileArticlesSvg'
import MobileBookingSvg from './MobileBookingSvg'
import MobileCommunitySvg from './MobileCommunitySvg'
import MobileHealthtoolsSvg from './MobileHealthtoolsSvg'
import UpDoubleArrowSvg from './UpDoubleArrowSvg'
import BellAlertSvg from './BellAlertSvg'
import BookmarkSavedSvg from './BookmarkSavedSvg'
import BookmarkSvg from './BookmarkSvg'
import CheckSvg from './CheckSvg'
import ChevronLeftSvg from './ChevronLeftSvg'
import ChevronRightSvg from './ChevronRightSvg'
import StarSparkleSvg from './StarSparkleSvg'
import TrendingSvg from './TrendingSvg'

export {
  DownDoubleArrowSvg,
  MobileArticlesSvg,
  MobileBookingSvg,
  MobileCommunitySvg,
  MobileHealthtoolsSvg,
  UpDoubleArrowSvg,
  BellAlertSvg,
  BookmarkSavedSvg,
  BookmarkSvg,
  CheckSvg,
  ChevronLeftSvg,
  ChevronRightSvg,
  StarSparkleSvg,
  TrendingSvg,
}
